//Please add the language resource
const create = {
  totalBoxQty: 'Total number of cases',
  totalPrice: 'Customer‘s total untaxed amount',
  totalPriceTax: 'Customer‘s total amount including tax',
  peerNumber:'Peer tracking number',
  createDate: 'Creation Date',
  orderValidDate: 'Order validity period',
  customerOrderNo: 'Purchase Order Number',
  productNo: 'Product No',
  shiptoNo: 'Customer Code (Ship To)',
  district: 'Detailed Address',
  materielNo: 'Material Number',
  productName: 'Product Name',
  otsCustomerProductNo: 'Customer Product Code',
  containerSize: 'Container Size',
  packageQty: 'Package Quantity',
  orderBoxQty: 'Order Box Quantity (CS)',
  customerPriceNoTax: 'Customer Price per Box (Excluding Tax)',
  materielTypeNo: 'Material Type',
  categoryName: 'Category',
  pickUpFlag: 'Self-pickup',
  fullGoodsFlag: 'Ship when all goods are ready',
  outStockNotCloseFlag: 'Do not close order if out of stock',
  peerOrderFlag: 'Peer order',
  soldtoName: 'Sold-to Name',
  lineNumber: 'Line Number',
  msg:{
    peerNumber: 'Please enter the peer tracking number',
    pickUpFlag: 'Self-pickup: please prepare the self-pickup authorization letter and contact the corresponding shipping DC;',
    peerOrderFlag: 'Peer order: requires adding the peer 308 order number',
    placeholder: 'Please select'
  }
};
export default create



// WEBPACK FOOTER //
// ./src/page/order/create/lang/create.en.js